import React from "react";
import { Table, Button } from "react-bootstrap";

const path_image = "https://informed.pro/componentAssets/images/"

const DragCommonTable = ({
    data = [],
    setData = () => { },
    columns = [],
    editingRowId,
    draggable = false,
    sourceType = '',
    onExternalDrop,
    className = "",
    type = "",
    expandedRowId,
    renderExpandedContent,
    draggedRowRef,
    dragSourceRef,
    onInternalDrop,
    handleAddRow,
    parentId
}) => {
  
  if (!columns.length)
    return (
      <div className="no_found">
        <p>No data defined</p>
      </div>
    );
  if (!data.length && type !== "child-topics")
    return (
      <div className="no_found">
        <p>No data found</p>
      </div>
    );


  return (
    <div className="onesource-common-table">
      <Table responsive>
        <thead className="sticky-header">
          <tr className={type === "topics" || type === "child-topics"  ? "topic-head" : ""}>
            {columns
              .filter((col) => !col.hidden)
              .map((col, colIndex) => (
                <th
                  key={colIndex}
                  className={`${className}-${colIndex}`}
                  style={col.sortable ? { cursor: "pointer" } : {}}
                  onClick={
                    col.sortable && col.onSort
                      ? () => col.onSort(col.key)
                      : undefined
                  }
                >
                  {col.label || ""}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {
            data.length === 0 && type === "child-topics" ? (
              <tr
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => {
                  if (dragSourceRef.current === sourceType) {
                    onInternalDrop?.(0);
                  } else {
                    onExternalDrop?.(0, draggedRowRef.current, dragSourceRef.current);
                  }
                }}
                style={{ height: "50px", textAlign: "center" }}
                className="no-data-found"
              >
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  <div className="data-not-available d-flex justify-content-end align-items-center">
                      <p>Add the first topic in this group</p>
                      <Button className="add" onClick={() => handleAddRow(0,'child',parentId)}>
                        <img src={path_image + "add-button-blue.svg"} alt=""/>
                      </Button>
                    </div>
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <React.Fragment key={row.id}>
                    <tr
                    className={
                      `${type === "topics" || type === "child-topics" ? "topic-body" : "view"} ` +
                      `${expandedRowId === row.id ? "expended" : ""}`
                    }
                    style={draggable ? { cursor: "grab" } : {}}
                    key={row.id || rowIndex}
                        draggable={editingRowId == row.id ? false : draggable}
                        onDragStart={(e) => {
                          if (editingRowId == row.id) {
                            e.preventDefault();
                            return false;
                          }
                          draggedRowRef.current = row;
                          dragSourceRef.current = sourceType;
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => {
                            if (dragSourceRef.current === sourceType) {
                              onInternalDrop?.(rowIndex);
                            } else {
                              onExternalDrop?.(rowIndex, draggedRowRef.current, dragSourceRef.current);
                            }
                        }}
                        >
                    {columns
                        .filter((col) => !col.hidden)
                        .map((col, colIndex) => {
                        const cellValue = row[col.key];
                        const tdExtraClass =
                            typeof col.tdClass === "function"
                            ? col.tdClass(cellValue, row)
                            : col.tdClass || "";
                        return (
                            <td
                            key={colIndex}
                            className={`${className}-${colIndex} ${tdExtraClass}`}
                            onClick={
                                col.onClick
                                ? (e) => {
                                    e.stopPropagation();
                                    col.onClick(cellValue, row);
                                }
                                : undefined
                            }
                            >
                            {col.render
                                ? col.render(cellValue ?? "-", row, rowIndex)
                                : cellValue ?? "-"}
                            </td>
                        );
                        })}
                    </tr>
                    {expandedRowId === row.id && renderExpandedContent ? (
                        <tr className="show">
                        <td colSpan={columns.length}>
                            {renderExpandedContent(row)}
                        </td>
                        </tr>
                    ) : null}
                    <tr className="blank">
                      <td colSpan={4}></td>
                    </tr>
                </React.Fragment>
              ))
            )
          }
        </tbody>
      </Table>
    </div>
  );
};

export default DragCommonTable;
